import { jsx as h } from "react/jsx-runtime";
import { forwardRef as d } from "react";
function m({ value: i, mask: t, tokens: l }) {
  var u;
  let e = 0, o = 0, a = "";
  for (; e < t.length && o < i.length; ) {
    const s = t[e], n = l[s], r = i[o];
    n ? ((u = n.pattern) != null && u.test(r) && (a += n.transform ? n.transform(r) : r, e++), o++) : (a += s, r === s && o++, e++);
  }
  let c = "";
  for (; e < t.length; ) {
    let s = t[e];
    if (l[s]) {
      c = "";
      break;
    }
    c += s, e++;
  }
  return a + c;
}
function g({ value: i, mask: t, tokens: l }, e) {
  t = t.sort((a, c) => a.length - c.length);
  let o = 0;
  for (; o < t.length; ) {
    const a = t[o];
    o++;
    const c = t[o];
    if (!(c && e({ value: i, mask: c, tokens: l }).length > a.length))
      return e({ value: i, mask: a, tokens: l });
  }
  return "";
}
function p({ value: i, mask: t, tokens: l }, e) {
  return Array.isArray(t) ? g({ value: i, mask: t, tokens: l }, e) : e({ value: i, mask: t, tokens: l });
}
const w = { "#": { pattern: /\d/ } }, x = d(
  ({ mask: i, tokens: t = w, onChange: l, component: e, ...o }, a) => /* @__PURE__ */ h(e || "input", { ...o, ref: a, onChange: (s) => {
    const n = s.target;
    let r = n.selectionEnd || 0;
    const f = n.value[r - 1];
    for (n.value = p({ value: n.value, mask: i, tokens: t }, m); r && r < n.value.length && n.value.charAt(r - 1).toLocaleLowerCase() !== f.toLocaleLowerCase(); )
      r++;
    n === document.activeElement && n.setSelectionRange(r, r), l == null || l(s);
  } })
);
x.displayName = "InputMask";
export {
  x as InputMask
};
